import { Injectable } from '@angular/core'

import { OAuthState, QueryString, User } from 'app/models'
import { environment } from 'environments/environment'

import { UserService } from './user.service'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private user: User
  private userAuthenticatedResult: Promise<User>

  constructor(private userService: UserService) {
    this.userAuthenticatedResult = new Promise<User>((resolve, reject) => {
      this.userService.current.subscribe((user: User) => {
        this.user = user
        if (user) {
          resolve(user)
        }
      })
    })
  }

  public async isAuthenticated(): Promise<boolean> {
    if (!this.user) {
      await this.userAuthenticatedResult
    }
    return this.user.isAuthenticated()
  }

  public async isAdmin(): Promise<boolean> {
    if (!this.user) {
      await this.userAuthenticatedResult
    }
    return this.user.hasRole('platform_admin') && this.user.hasRole('elasticsearch_admin')
  }

  public async isSupportAdmin(): Promise<boolean> {
    if (!this.user) {
      await this.userAuthenticatedResult
    }
    return this.user.hasRole('support_admin')
  }

  public initiateLogin(returnURL: string): void {
    const state = new OAuthState({ returnTo: returnURL })
    state.save()
    window.location.href = this.redirectUrl(state.state, returnURL)
  }

  public initiateSignOut(returnURL: string): void {
    window.location.href = `${environment.userUrl}/oauth/sign_out?redirect_uri=${window.location.origin + returnURL}`
  }

  private redirectUrl(state: string, returnURL: string): string {
    const queryParams: any = {
      client_id: environment.clientId,
      membership: returnURL.includes('/buy') || returnURL.includes('/org'),
      redirect_uri: window.location.origin + '/oauth/callback',
      response_type: 'none',
      state: state
    }
    return environment.userUrl + '/oauth/authorize?' + QueryString.build(queryParams)
  }
}
